<template>
  <div id="adminSelenaViews">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ setting }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Tipologie Allegati</router-link>
      </li>
    </ol>
    <div class="container-fluid card-title-admin">
      <div class="row">
        <div class="col-8 align-self-center">
          <h1>Tipologia</h1>
        </div>
        <div class="col-4 align-self-center">
          <div class="row" v-if="viewBtn">
            <div class="col-5 align-self-center text-right">
              <label class="label-name" style="margin-bottom: 0px">Online</label><br>
              <label
                class="switch switch-pill switch-primary"
                style="margin: 2px; margin-bottom: -2px; vertical-align: bottom;margin-bottom:10px;"
              >
                <input
                  type="checkbox"
                  class="switch-input"
                  :checked="checkOnlineItem"
                  id="idOnlineItemAttachement"
                />
                <span class="switch-slider" data-on data-off></span>
              </label>
            </div>
            <div class="col-7 align-self-center text-right">
              <button
                type="button"
                class="btn btn-danger"
                data-dismiss="modal"
                @click="cancelNewNation"
              ><i class="fa fa-times"></i>&nbsp;{{ cancel }}</button>
              <button
                type="button"
                class="btn btn-success"
                @click="saveNewNation"
              ><i class="fa fa-floppy-o"></i>&nbsp;{{ save }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
     <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane nopadding active" id="tabTable" role="tabpanel">
            <div class="row align-btn">
              <div class="col-lg-12 text-left">
                <button
                  id="btnAdd"
                  type="button"
                  class="btn btn-primary"
                  @click="onClickNew"
                >
                  <i class="fa fa-plus"></i>
                  <span>{{ add }}</span>
                </button>
              </div>
            </div>
            <div class="card-body">
              <bootstrapTable
                :configurations="tableConfiguration"
                :datas="tableData"
                id="tableContents"
                ref="tableContents"
                :onCheck="onTableCheckCustomer"
                :results="tableNationResult"
              ></bootstrapTable>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabNationDetail" role="tabpanel">
            <div class="card-body" style="padding: 30px;">
              <div class="row">
                <pageDetail
                  functions="AdminSettingNation"
                  :configurations="detailNationConfiguration"
                  :jsonValue="detailNationData"
                ></pageDetail>
              </div>
              <div class="row" v-if="rowIdSelected>0">
                <div class="col-12">
                  <hr>
                </div>
              </div>
              <div class="row" v-if="rowIdSelected>0">
                <div class="col-md-10 align-self-center" >
                  <h1 style="margin-top: 10px; font-size: 30px; font-weight: lighter; color: rgb(48, 60, 84);">Traduzioni</h1>
                </div>
                <div class="col-md-2 text-right align-self-center">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="addOptionList"
                  >
                    <i class="fa fa-plus"></i>
                    <span>{{ add }}</span>
                  </button>
                  <!--i class="fa fa-plus-circle fa-lg" style="margin-top:25px;cursor:pointer;" @click="addOptionList"></!--i-->
                </div>
              </div>
              <div id="div-cont-options"></div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";
import Select2 from "@/components/Select2.vue";
export default {
  name: "adminSelenaViews",
  components: {
    BootstrapTable,
    PageDetail,
    Select2
  },
  data: function() {
    return {
      cont: 0,
      viewBtn: false,
      checkOnlineItem: true,
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      save: dictionaryHelpers.getDictionary("Save"),
      setting: dictionaryHelpers.getDictionary("Setting"),
      language: dictionaryHelpers.getDictionary("Language"),
      updateCompleted: dictionaryHelpers.getDictionary('UpdateCompleted'),
      insertCompleted: dictionaryHelpers.getDictionary('InsertCompleted'),
      defaultLanguageOptions: [],
      detailNationConfiguration: [],
      tableNationResult: [],
      detailNationData: {},
      tableConfiguration: [],
      pageValueSelected: {
        id: 0,
        languagePageSetting: { content: null }
      },
      tableData: [],
      disableButton: true,
      url: window.location.pathname
    };
  },
  created() {
    var adminSelenaViews = this;

    spinnerHelpers.show();
    adminSelenaViews.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage()
    };

    spinnerHelpers.show();
    adminConfigurationServices.getFunctionality(function(result) {
      
      adminSelenaViews.tableConfiguration = result.data.tablesConfigurations[0].tablesConfigurations;
      adminSelenaViews.detailNationConfiguration = result.data.tabsConfigurations[0].pageConfigurations;

      adminSelenaViews.loadTable();
    });
  },
  methods: {
    loadTable(ln) {
      var adminSelenaViews = this;
      if(!functionHelpers.isValued(ln)){
        ln = storageData.sIdLanguage();
      }
      
      itemAttachmentTypeServices.getAll(ln,function(result) {
        
        adminSelenaViews.tableData = result.data;
        spinnerHelpers.hide();
      });
    },
    onTableCheckCustomer() {
      var countRowSelected = this.$refs.tableContents.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },
    ItemAttachmentTypeFormatter(value, row, index, field) {
      var adminSelenaViews = this;
      var html = "";
      '<div class="container-fluid" style="min-width:80px;"><div class="row">';
      html +=
         '<button class="btn btn-success" onclick="adminSelenaViews.__vue__.viewDatailInfo(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button>';
          html +=
         '<button class="btn btn-danger" onclick="adminSelenaViews.__vue__.delete(' +
        row.id +
        ')"><i class="fa fa-trash"/></button>';
      return html;
    },

    viewDatailInfo(id){
      spinnerHelpers.show();
      var adminSelenaViews = this;
      this.rowIdSelected = id;
      this.viewBtn = true;

      $.each(this.tableData, function(i, row) {
        if (adminSelenaViews.rowIdSelected == row.id) {
          
          
          /* inserimento lingue se presenti */
          $("#div-cont-options").html('');
          var itemAttachmentLanguageType = row.itemAttachmentLanguageType;
          if (itemAttachmentLanguageType.length > 0) {
            adminSelenaViews.cont = itemAttachmentLanguageType.length;
            
            for (var j = 0; j < itemAttachmentLanguageType.length; j++) {
              var html = "";
              html += '<div class="row" data-id-img-agg="' + j + '" style="margin-bottom:5px;">';
              html += '<div class="col-md-2 align-self-center">';
              html += '<label class="labelclass">Lingua</label><br>';
              html += '<select class="custom-select optional_id_select" style="min-height: 52px;" id="optional_id' + j + '" value="' + itemAttachmentLanguageType[j].language_id + '" name="optional_id' + j + '"></select>';
              html += "</div>";
              html += '<div class="col-md-4 align-self-center">';
              html += '<label for="description_new" class="labelclass">Descrizione</label>';
              html += '<input type="text" style="min-height: 52px" class="form-control cost" id="cost' + j + '" name="cost' + j + '" value="' + itemAttachmentLanguageType[j].description + '">';
              html += '</div>';
              html += '<div class="col-2">';
              html += '<button type="button" style="margin-top: 30px;" class="btn btn-danger del-img-agg" data-id-cont="' + j + '" id="btndelete' + j + '"><i class="fa fa-trash"></i></button>';
              html += '</div>';
              html += '</div>';

              $("#div-cont-options").append(html);

              var searchParam = "";
              var initials = [];
                initials.push({
                id: itemAttachmentLanguageType[j].language_id,
                text: itemAttachmentLanguageType[j].description,
              }); 
            
              $('#optional_id' + j).select2({
                data: initials,
                ajax: {
                  url: configData.wsRootServicesUrl + '/api/v1/language/select',
                  data: function (params) {
                    if (params.term == '') {
                      searchParam = '*';
                    } else {
                      searchParam = params.term;
                    }
                    var query = {
                      search: searchParam,
                    }
                    return query;
                  },
                  processResults: function (data) {
                    var dataParse = JSON.parse(data);
                    return {
                      results: dataParse.data
                    };
                  }
                }
              });
            }
          }
          /* end inserimento lingue se presenti */
          $("#div-cont-options .del-img-agg").on("click", function(e) {
            var idDel = $(this).attr('data-id-cont');
            var el = $(this).parent('div').parent('div').attr('data-id-img-agg', idDel);
            adminSelenaViews.cont = adminSelenaViews.cont - 1;
            if(adminSelenaViews.cont < 0){
              adminSelenaViews.cont = 0;
            }
            el.remove();
          });

          adminSelenaViews.detailNationData = row;
          adminSelenaViews.checkOnlineItem = adminSelenaViews.detailNationData.online;
        }
      });

      $("#tabTable").removeClass("active");
      $("#tabNationDetail").addClass("active");
      spinnerHelpers.hide();

    },
    delete(id) {
      var adminSelenaViews = this;
      this.viewBtn = false;
      spinnerHelpers.show();
      itemAttachmentTypeServices.del(id, function() {
        notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted"));
        var ln = adminSelenaViews.pageValueSelected.languagePageSetting.idLanguage;
        if (!functionHelpers.isValued(ln)) {
          ln = storageData.sIdLanguage();
        }
        adminSelenaViews.loadTable(ln);
        window.scrollTo(0, 0);
      });
    },
    onClickNew() {
      spinnerHelpers.show();
      var adminSelenaViews = this;
      this.viewBtn = true;
      adminSelenaViews.rowIdSelected = '';
      adminSelenaViews.detailNationData.description = '';
      adminSelenaViews.detailNationData.id= '';
      adminSelenaViews.detailNationData.idFunctionality= '';
      adminSelenaViews.detailNationData.order= '';
      adminSelenaViews.detailNationData.typeOptional= '';
      adminSelenaViews.detailNationData.typeOptionalId= '';

     // this.detailNationData = {};
      $("#tabTable").removeClass("active");
      $("#tabNationDetail").addClass("active");
      spinnerHelpers.hide();
    },
    cancelNewNation(){
      spinnerHelpers.show();
      this.detailNationData = {};
      this.rowIdSelected = 0;
      this.viewBtn = false;
      $("#tabTable").addClass("active");
      $("#tabNationDetail").removeClass("active");
      spinnerHelpers.hide();
    },
    saveNewNation(){
      spinnerHelpers.show();
      var adminSelenaViews = this;
      this.detailNationData.idFunctionality = menuHelpers.getIdFunctionByAdminUrl();

      if (functionHelpers.isValued(this.rowIdSelected) && this.rowIdSelected > 0) {
        this.detailNationData.id = this.rowIdSelected;
    
        var arrayOption = [];
          
        for (var i = 0; i < 50; i++) {
          var jsonOption = {};
          var check_each = false;

          if (functionHelpers.isValued($("#cost" + i).val())) {
            jsonOption["cost"] = $("#cost" + i).val();
          }

          if (functionHelpers.isValued($("#optional_id" + i).val())) {
            jsonOption["optional_id"] = $("#optional_id" + i).val();
          }
          
          if (functionHelpers.isValued($("#optional_id" + i).val()) && functionHelpers.isValued($("#cost" + i).val())) {
            arrayOption.push(jsonOption);
          }
        }

        this.detailNationData.translateDescription = arrayOption;
        if($('#idOnlineItemAttachement').is(":checked")){
          this.detailNationData.online = true;
        }else{
          this.detailNationData.online = false;
        }

        itemAttachmentTypeServices.update(this.detailNationData, function (result) {
          notificationHelpers.success(adminSelenaViews.updateCompleted);
          adminSelenaViews.loadTable();
          adminSelenaViews.rowIdSelected = 0;
          adminSelenaViews.viewBtn = false;
          $('#tabTable').addClass('active');
          $('#tabNationDetail').removeClass('active');
        })
      } else {
        itemAttachmentTypeServices.insert(this.detailNationData, function (result) {
          notificationHelpers.success(adminSelenaViews.insertCompleted);
          adminSelenaViews.loadTable();
          adminSelenaViews.rowIdSelected = 0;
          adminSelenaViews.viewBtn = false;
          $('#tabTable').addClass('active');
          $('#tabNationDetail').removeClass('active');
        })
      }
    },
    addOptionList() {
      var adminCrmConnections = this;
      var html = "";

      if (adminCrmConnections.cont  < 10) {
          adminCrmConnections.cont = adminCrmConnections.cont + 1;

          html += '<div class="row" data-id-img-agg="' + adminCrmConnections.cont + '" style="margin-bottom:5px;">';
          html += '<div class="col-md-2 align-self-center">';
          html += '<label class="labelclass">Lingua</label><br>';
          html += '<select class="custom-select optional_id_select" style="min-height: 52px;" id="optional_id' + adminCrmConnections.cont + '" value="' + adminCrmConnections.cont + '" name="optional_id' + adminCrmConnections.cont + '"></select>';
          html += "</div>";
          html += '<div class="col-md-4 align-self-center">';
          html += '<label for="description_new" class="labelclass">Descrizione</label>';
          html += '<input type="text" style="min-height: 52px" class="form-control cost" id="cost' + adminCrmConnections.cont + '" name="cost' + adminCrmConnections.cont + '">';
          html += '</div>';
          html += '<div class="col-2">';
          html += '<button type="button" style="margin-top: 30px;" class="btn btn-danger del-img-agg" data-id-cont="' + adminCrmConnections.cont + '" id="btndelete' + adminCrmConnections.cont + '"><i class="fa fa-trash"></i></button>'
          html += "</div>";
          html += '</div>';

          $("#div-cont-options").append(html);
      }

      $.getScript("https://cdn.jsdelivr.net/npm/select2@4.1.0-beta.1/dist/js/select2.min.js").done(function(){ 
        var searchParam = "";
        $('#optional_id' + adminCrmConnections.cont).select2({
          ajax: {
          url: configData.wsRootServicesUrl + '/api/v1/language/select',
          data: function (params) {
            if(params.term==''){
              searchParam = '*';
            }else{
            searchParam = params.term;
            }
            var query = {
            search: searchParam,
            }
            return query;
          },
          processResults: function (data) {
            var dataParse = JSON.parse(data);
            return {
            results: dataParse.data
            };
          }
          }
        }); 
      });

      $("#div-cont-options .del-img-agg").on("click", function(e) {
        var idDel = $(this).attr('data-id-cont');
        var el = $(this).parent('div').parent('div').attr('data-id-img-agg', idDel);
        adminCrmConnections.cont = adminCrmConnections.cont - 1;
        if(adminCrmConnections.cont < 0){
          adminCrmConnections.cont = 0;
        }
        el.remove();
      });

    },
  }
};
</script>
<style>

.card-title-admin h1{
  font-size:40px;
  font-weight: lighter;
  color:#303C54;
}
.align-btn {
  position: absolute;
  margin-top: 30px;
  margin-left: 5px;
  z-index: 1;
}


.labelclass {
    color: rgba(0,0,0,.87);
    font-size: 12px;
    padding: 0 2px;
    margin: 0 0 -2px;
    font-family: Avenir,Helvetica,Arial,sans-serif;
    background: #fff;
}

</style>
